/**
 * API path fragments — if request URL includes any of these, success/error toasts are suppressed.
 * Matching: axiosConfig uses `url.includes(path)`.
 *
 * Keep path fragments stable (no query strings). Dynamic IDs are covered by parent paths
 * e.g. `food_scanner/edit_food_items/` matches `/food_scanner/edit_food_items/{id}/`.
 */
export const hidenMessageAPI = [
  // ── Auth & account ────────────────────────────────────────
  "auth/login",
  "auth/logout",
  "auth/token-refresh",
  "auth/password/change",
  "auth/staticGoogleLogin",
  "auth/", // signup + social login (/auth/{provider}/login/)
  "forgot-password-request",
  "forgot-password-reset",

  // ── Assessment ────────────────────────────────────────────
  "new-assessment/check_assessment_completion",
  "new-assessment",
  "/assessment",

  // ── File & images ─────────────────────────────────────────
  "file-utility/files",
  "file-utility/images",
  "/images/",

  // ── Fitbit / activity ─────────────────────────────────────
  "fitbit_scan/daily",
  "fitbit_scan/monthly",
  "fitbit_scan/sync-all",
  "fitbit_scan/stress-score",
  "fitbit_scan/steps-graph",
  "fitbit_scan/calories-graph",
  "fitbit_scan/heart-rate-graph",
  "fitbit_scan/sleep-graph",
  "fitbit_scan/hrv-graph",
  "fitbit_scan/active-zone-minutes-graph",
  "fitbit_scan/weight-graph",
  "fitbit_scan/login",
  "fitbit_scan/callback",
  "fitbit_scan/refresh",
  "fitbit_scan/status",
  "fitbit_scan/disconnect",
  "fitbit-scan/", // legacy alt path (activityConfig)
  "api/fitbit_scan/", // FitbitAuthService status/disconnect

  // ── Food scanner — home, trends, meals ────────────────────
  "food_scanner/food-home-page",
  "food-home-page",
  "food_scanner/trends",
  "food_scanner/health/sync",
  "food_scanner/health-sync",
  "food_scanner/analyze_food_image",
  "food_scanner/add_food_items",
  "food_scanner/edit_food_items",
  "food_scanner/delete_food_items",
  "food_scanner/meal_data/save",
  "food_scanner/meal_data/get",
  "food_scanner/meal_data",
  "food_scanner/meals",
  "food_scanner/get_meal_history",
  "food_scanner/food-items",
  "food_scanner/food-items/suggestions",
  "food_scanner/manual-food/edit",

  // ── Glucose, measure, medication, exercise ────────────────
  "food_scanner/glucose-readings/intervention/calculate",
  "food_scanner/glucose-readings",
  "food_scanner/measure",
  "food_scanner/medication/crud",
  "food_scanner/medication/done",
  "food_scanner/manual-exercise",

  // ── Profile, goals, preferences ───────────────────────────
  "food_scanner/profile",
  "food_scanner/edit-profile",
  "food_scanner/goal",
  "food_scanner/preferences",
  "user-preferences-general",

  // ── Nutrition & fasting ───────────────────────────────────
  "food_scanner/nutrition/daily",
  "food_scanner/nutrition/weekly",
  "food_scanner/nutrition/monthly",
  "food_scanner/nutrition/targets",
  "food_scanner/intermittent-fasting",

  // ── Coaching & workouts ─────────────────────────────────────
  "food_scanner/coaching/insights",
  "food_scanner/coaching/recipes",
  "food_scanner/workouts/suggested",
  "food_scanner/workouts/log",
  "food_scanner/workouts/history",
  "food_scanner/workouts/today",
  "food_scanner/workouts/", // GET /workouts/{id}/
  "food_scanner/exercise-videos",

  // ── Family groups ─────────────────────────────────────────
  "food_scanner/family/groups",
  "food_scanner/family/invite/send",
  "food_scanner/family/invite/accept",
  "food_scanner/family/invite/reject",
  "food_scanner/family/invite/details",
  "food_scanner/family/invite/pending",
  "food_scanner/family/invite/", // DELETE invite/{id}/
  "food_scanner/family/nudge",
  "food_scanner/family/meal-log/details",
  "food_scanner/family/meal-log/approve",
  "food_scanner/family/meal-log/reject",
  "food_scanner/family/groups/", // approve-member / reject-member

  // ── Platform / admin (shared architecture) ─────────────────
  "/users/",
  "menu/menus",
  "dropdown/",
  "dropdown/manage-active-record",
  "tenant-permissions/permissions",
  "tenant-permissions/roles",
  "tenant-permissions/user-roles",
  "tenant-permissions/user-permissions",
  "tenant-permissions/roles_by_user",
  "tenant-core/translations",
  "social-login-config",
  "formily/schemas",
  "formily/dynamic-model",
  "workflow/workflows",
  "workflow/actions",
  "workflow/action-masters",
  "workflow/state-masters",
  "workflow/status",
  "workflow/onAction",
  "export-data/",
  "import-data/create",
  "run-import/",
  "data-import/",
];
